import { DownOutlined, UpOutlined } from "@ant-design/icons"
import { Col, Row } from "antd"
import { ProfilePageData } from "libs/profile-repo"
import { dateFormat, getEnumLabel } from "libs/utils"
import React, { useState } from "react"
import ProfileDetailItemH5 from "./ProfileDetailItemH5"

export default function ProfileBusinessDetailH5({
  businessDetail,
  enumState,
  categoryTree,
}: ProfilePageData) {
  const [showMoreContract, setShowMoreContract] = useState(false)
  const [showMoreDelivery, setShowMoreDelivery] = useState(false)
  const [showMoreStaff, setShowMoreStaff] = useState(false)
  const [showMoreWarehouse, setShowMoreWarehouse] = useState(false)

  const renderContractList = showMoreContract
    ? businessDetail.performance.contractList
    : businessDetail.performance.contractList?.slice(0, 3)
  const deliveryList = showMoreDelivery
    ? businessDetail.logistics.deliveryList
    : businessDetail.logistics.deliveryList?.slice(0, 3)
  const staffList = showMoreStaff
    ? businessDetail.staff.staffList
    : businessDetail.staff.staffList?.slice(0, 3)
  const warehouseList = showMoreWarehouse
    ? businessDetail.warehouse.warehouseList
    : businessDetail.warehouse.warehouseList?.slice(0, 3)

  function categoryName(sysNo) {
    for (const firstLevelCategory of categoryTree) {
      if (!firstLevelCategory.children?.length) {
        continue
      }

      for (const secondLevelCategory of firstLevelCategory.children) {
        if (secondLevelCategory.sysNo === sysNo) {
          return `${firstLevelCategory.name} / ${secondLevelCategory.name}`
        }
      }
    }
    return sysNo
  }

  return (
    <div>
      <div className="card-wrap">
        <h3 className="title">企业信息</h3>
        <Row>
          <Col span={12}>
            <ProfileDetailItemH5 label="年营业额">
              {getEnumLabel({
                enums: enumState.SupplierIncomeAmountEnum,
                value: businessDetail.performance.incomeAmount,
              })}
            </ProfileDetailItemH5>
          </Col>
          <Col span={12}>
            <ProfileDetailItemH5 label="供货品牌">
              {businessDetail.brand?.brandList
                ?.map?.((item) => item.brandName)
                ?.join("，")}
            </ProfileDetailItemH5>
          </Col>
        </Row>
      </div>
      <div className="card-wrap">
        <h3 className="title">历史合同</h3>
        <div>
          {renderContractList.map((item, index) => (
            <div key={index} className="card-item-wrap">
              <Row>
                <Col flex="0 0 50px">
                  <div className="index-wrap">
                    <div>
                      <ProfileDetailItemH5 label="序号">
                        {index + 1}
                      </ProfileDetailItemH5>
                    </div>
                  </div>
                </Col>
                <Col flex={1}>
                  <Row gutter={10}>
                    <Col span={12}>
                      <ProfileDetailItemH5 label="采购品类">
                        {categoryName(item.purchaseCategoryName)}
                      </ProfileDetailItemH5>
                    </Col>
                    <Col span={12}>
                      <ProfileDetailItemH5 label="合同金额">
                        {item.contractAmount}万
                      </ProfileDetailItemH5>
                    </Col>
                  </Row>
                  <Row gutter={10}>
                    <Col span={12}>
                      <ProfileDetailItemH5 label="签订日期">
                        {dateFormat(item.contractDate)}
                      </ProfileDetailItemH5>
                    </Col>
                    <Col span={12}>
                      <ProfileDetailItemH5 label="采购方">
                        {item.purchaserName}
                      </ProfileDetailItemH5>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          ))}
        </div>
        {businessDetail.performance.contractList?.length > 3 && (
          <div
            className="more-btn"
            onClick={() => {
              setShowMoreContract(!showMoreContract)
            }}
          >
            {showMoreContract ? (
              <>
                收起
                <UpOutlined style={{ fontSize: "9px", marginLeft: "5px" }} />
              </>
            ) : (
              <>
                更多
                <DownOutlined style={{ fontSize: "9px", marginLeft: "5px" }} />
              </>
            )}
          </div>
        )}
      </div>
      <div className="card-wrap">
        <h3 className="title">物流信息</h3>
        <div>
          {deliveryList.map((item, index) => (
            <div key={index} className="card-item-wrap">
              <Row>
                <Col flex="0 0 50px">
                  <div className="index-wrap">
                    <div>
                      <ProfileDetailItemH5 label="序号">
                        {index + 1}
                      </ProfileDetailItemH5>
                    </div>
                  </div>
                </Col>
                <Col flex={1}>
                  <Row gutter={10}>
                    <Col span={8}>
                      <ProfileDetailItemH5 label="配送地区">
                        {item.areaName}
                      </ProfileDetailItemH5>
                    </Col>
                    <Col span={8}>
                      <ProfileDetailItemH5 label="配送时效">
                        {getEnumLabel({
                          enums: enumState.SupplierDeliveryLimitationEnum,
                          value: item.deliveryPeriod,
                        })}
                      </ProfileDetailItemH5>
                    </Col>
                    <Col span={8}>
                      <ProfileDetailItemH5 label="配送方式">
                        {getEnumLabel({
                          enums: enumState.SupplierDeliveryWayEnum,
                          value: item.deliveryWay,
                        })}
                      </ProfileDetailItemH5>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          ))}
        </div>
        {businessDetail.logistics.deliveryList?.length > 3 && (
          <div
            className="more-btn"
            onClick={() => {
              setShowMoreDelivery(!showMoreDelivery)
            }}
          >
            {showMoreDelivery ? (
              <>
                收起
                <UpOutlined style={{ fontSize: "9px", marginLeft: "5px" }} />
              </>
            ) : (
              <>
                更多
                <DownOutlined style={{ fontSize: "9px", marginLeft: "5px" }} />
              </>
            )}
          </div>
        )}
      </div>
      <div className="card-wrap">
        <h3 className="title">员工配置</h3>
        <div>
          {staffList.map((item, index) => (
            <div key={index} className="card-item-wrap">
              <Row justify="space-between" gutter={0}>
                <Col flex="0 0 50px">
                  <div className="index-wrap">
                    <div>
                      <ProfileDetailItemH5 label="序号">
                        {index + 1}
                      </ProfileDetailItemH5>
                    </div>
                  </div>
                </Col>
                <Col flex={1}>
                  <Row gutter={10}>
                    <Col span={6}>
                      <ProfileDetailItemH5 label="姓名">
                        {item.name}
                      </ProfileDetailItemH5>
                    </Col>
                    <Col span={12}>
                      <ProfileDetailItemH5 label="联系方式">
                        {item.phone}
                      </ProfileDetailItemH5>
                    </Col>
                    <Col span={6}>
                      <ProfileDetailItemH5 label="职责范围">
                        {getEnumLabel({
                          enums: enumState.SupplierResponsibilityScopeEnum,
                          value: item.responsibilityScope,
                        })}
                      </ProfileDetailItemH5>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          ))}
        </div>
        {businessDetail.logistics.deliveryList?.length > 3 && (
          <div
            className="more-btn"
            onClick={() => {
              setShowMoreStaff(!showMoreStaff)
            }}
          >
            {showMoreStaff ? (
              <>
                收起
                <UpOutlined style={{ fontSize: "9px", marginLeft: "5px" }} />
              </>
            ) : (
              <>
                更多
                <DownOutlined style={{ fontSize: "9px", marginLeft: "5px" }} />
              </>
            )}
          </div>
        )}
      </div>
      <div className="card-wrap">
        <h3 className="title">仓储能力</h3>
        <div>
          {warehouseList.map((item, index) => (
            <div key={index} className="card-item-wrap">
              <Row>
                <Col flex="0 0 50px">
                  <div className="index-wrap">
                    <div>
                      <ProfileDetailItemH5 label="序号">
                        {index + 1}
                      </ProfileDetailItemH5>
                    </div>
                  </div>
                </Col>
                <Col flex={1}>
                  <Row gutter={10}>
                    <Col span={12}>
                      <ProfileDetailItemH5 label="仓库所在地">
                        {item.areaName}
                      </ProfileDetailItemH5>
                    </Col>
                    <Col span={12}>
                      <ProfileDetailItemH5 label="仓储面积">
                        {getEnumLabel({
                          enums: enumState.SupplierWarehouseAreaEnum,
                          value: item.area,
                        })}
                      </ProfileDetailItemH5>
                    </Col>
                  </Row>
                  <Row gutter={10}>
                    <Col span={12}>
                      <ProfileDetailItemH5 label="库存金额">
                        {getEnumLabel({
                          enums: enumState.SupplierWarehouseStockAmountEnum,
                          value: item.inventoryAmount,
                        })}
                      </ProfileDetailItemH5>
                    </Col>
                    <Col span={12}>
                      <ProfileDetailItemH5 label="详细地址">
                        {item.address}
                      </ProfileDetailItemH5>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          ))}
        </div>
        {businessDetail.warehouse.warehouseList?.length > 3 && (
          <div
            className="more-btn"
            onClick={() => {
              setShowMoreWarehouse(!showMoreWarehouse)
            }}
          >
            {showMoreWarehouse ? (
              <>
                收起
                <UpOutlined style={{ fontSize: "9px", marginLeft: "5px" }} />
              </>
            ) : (
              <>
                更多
                <DownOutlined style={{ fontSize: "9px", marginLeft: "5px" }} />
              </>
            )}
          </div>
        )}
      </div>

      <style jsx>{`
        .card-wrap {
          background: #ffffff;
          border-radius: 3px;
          padding: 14px 15px 1px 15px;
          margin-bottom: 10px;
          line-height: 1;
        }
        .title {
          font-size: 17px;
          color: #333333;
          margin: 0;
          margin-bottom: 20px;
        }
        .card-item-wrap {
          border-bottom: 1px solid #eeeeee;
          padding-top: 20px;
        }
        .card-item-wrap:first-child {
          padding-top: 0;
        }
        .card-item-wrap:last-child {
          border-bottom: none;
        }

        .index-wrap {
          display: flex;
          text-align: center;
        }
        .more-btn {
          border-top: 1px solid #eee;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #666666;
          font-size: 12px;
        }
      `}</style>
    </div>
  )
}
